import { render, staticRenderFns } from "./AGBView.vue?vue&type=template&id=0c986a7a"
import script from "./AGBView.vue?vue&type=script&lang=js"
export * from "./AGBView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports